import React, { Component } from 'react';
import {bindActionCreators} from 'redux';
import { connect } from 'react-redux';
import { change as changeFieldValue, reduxForm} from 'redux-form';
import DatePicker, { registerLocale, setDefaultLocale } from 'react-datepicker';
import 'moment/locale/pt-br'
import 'react-datepicker/dist/react-datepicker.css';
import $ from 'jquery';
import ptBR from 'date-fns/locale/pt-BR';
import moment from 'moment';
import bloquerUsuarioEmpresaItinerarioEmLote from '../../actions/itinerario/bloquerUsuarioEmpresaItinerarioEmLote';
import {showSuccessMsg} from '../../util/messagesUtil';
import FieldsetBloquearVendedores from './FieldsetBloquearVendedores';

registerLocale('pt-BR', ptBR);
setDefaultLocale('pt-BR');

class ModalBloquearUsuarioEmpresaItinerarioPorEmLote extends Component {
    constructor(props) {
        super(props);
        this.submit = this.submit.bind(this);          
        this.state = {
            dataInicio: null, dataFim: null, usuarioEmpresaBloqueioSelecionados: []
        }
    }
     
    
    selecionarData(data, inicio) {
        if (inicio) {
            this.setState({dataInicio: data, dataFim: null})
        } else {
            this.setState({data, dataFim: data})
        }
    }

    removerUarioEmpresaBloqueioSelecionados(idCidade){
        this.setState({usuarioEmpresaBloqueioSelecionados: this.state.usuarioEmpresaBloqueioSelecionados.filter(it => !(it.value === idCidade))})
    }

    selecionarVendedorParaBloquear(vendedor) {
        console.log('VENDEDOR: '+vendedor)
        const usuarios = this.state.usuarioEmpresaBloqueioSelecionados;
        usuarios.push(vendedor);
        this.setState({usuarioEmpresaBloqueioSelecionados: usuarios})
    }

    exibirCalendario(inicio) {
        let data;

        let minDate = new Date();
        if (inicio) {
            if (this.state.dataInicio) {
                data = moment(this.state.dataInicio)
                    .toDate()
            }
        } else {
            minDate = moment(this.state.dataInicio)
                .add(1, 'days')
                .toDate();
            if (this.state.dataFim) {
                data = moment(this.state.dataFim)
                    .toDate()
            }
        }

        
        return (
            <div>
                <div className="linha">
                    <DatePicker
                        className='form-control col-md-12'
                        value={data}
                        locale="pt-BR"
                        minDate={minDate}
                        selected={data}
                        startDate={moment(this.state.dataInicio)
                            .toDate()}
                        endDate={moment(this.state.dataFim)
                            .toDate()}
                        disabled={!inicio && !this.state.dataInicio}
                        onChange={date => this.selecionarData(date, inicio)}
                        dateFormat="dd/MM/yyyy"
                        withPortal
                    />
                </div>
            </div>
        )
    }

    montarParametroItinerario() {        
        return {
            dataInicio: moment(this.state.dataInicio).format('DD/MM/YYYY'),
            dataFim: moment(this.state.dataFim).format('DD/MM/YYYY'),            
            empresaId: this.props.empresaSelecionada.id,
            idsUsuarioEmpresa: this.state.usuarioEmpresaBloqueioSelecionados ? this.state.usuarioEmpresaBloqueioSelecionados.map(it => it.value) : null,
            
        }
    }

    submit() {  
        
        const parametros = this.montarParametroItinerario()        
        this.props.bloquerUsuarioEmpresaItinerarioEmLote(parametros) 
        .then(() => {
            showSuccessMsg('Bloqueios realizado com sucesso');
            this.fecharModal();
            this.props.buscarItinerarios();
        })     
    }

    adicionarCidade(event){       
        event.preventDefault();        
        const cidade = this.props.cidade;   
        
        if(this.state.usuarioEmpresaBloqueioSelecionados.filter(it => it.value === cidade.value).length ===  0){
          
            const usuarioEmpresaBloqueioSelecionados = this.state.usuarioEmpresaBloqueioSelecionados;
            usuarioEmpresaBloqueioSelecionados.push(cidade);
            this.setState({usuarioEmpresaBloqueioSelecionados: usuarioEmpresaBloqueioSelecionados})
        }
        this.props.changeFieldValue('formularioBloquearUsuarioEmpresaItinerarioPorEmLote',
        'cidade', null);
    }


    fecharModal() {
        $('#modalBloquearItinerarioPorCidadeEmLote')
            .modal('hide');
        $('#modalBloquearItinerarioPorCidadeEmLote')
            .hide();
        $('.modal-backdrop')
            .hide();
        this.limparFormulario();
    }

    limparFormulario() {
        this.props.reset('formularioBloquearUsuarioEmpresaItinerarioPorEmLote');
        this.setState({dataInicio: null, dataFim: null, diasSelecionados: [], usuarioEmpresaBloqueioSelecionados: []});        
    }


    exibirCidadesSelecionadas() {        
        return (
            <table className="table table-sm table-bordered">
            <thead>
            <tr className='text-center'>
                <th colSpan='3'>Cidades Bloqueadas</th>
            </tr>
            <tr>
                <th>Cidade</th>               
                <th/>
            </tr>
            </thead>
            <tbody>
            {!this.state.usuarioEmpresaBloqueioSelecionados || this.state.usuarioEmpresaBloqueioSelecionados.length === 0 ?
                <tr className="alert alert-warning text-center mt-4" role="alert">
                    <td colSpan='3'>Nenhuma cidade foi
                        bloqueada.
                    </td>
                </tr>
                :
                this.state.usuarioEmpresaBloqueioSelecionados
                    .map((cidade,i) => <tr key={i}>
                        <td>
                            {cidade.label}
                        </td>                       
                        <td className='text-center' style={{cursor: 'pointer', color: 'red'}}>
                            <div
                                onClick={() => this.removerCidadeSelecionadaEmLote(cidade.value)}>Remover
                            </div>
                        </td>
                    </tr>)}
                </tbody>
            </table>
        )
        
    }
          
    
    formulario() {
        const {
            handleSubmit, submitting, invalid
        } = this.props; 
        
        return (            
            <>
                <form onSubmit={handleSubmit(this.submit)}>
                    <fieldset className="scheduler-border">
                        <legend className="scheduler-border">Informações básicas</legend>                       
                        <div className="col-12 col-sm-4 col-md-2 mt-2">
                            <label>Quando começa?</label>
                            {this.exibirCalendario(true)}
                        </div>
                        <div className="col-12 col-sm-4 col-md-2 mt-2">
                            <label>Quando encerra?</label>
                            {this.exibirCalendario()}
                        </div>                                                
                                              
                    </fieldset> 
                    <FieldsetBloquearVendedores
                        usuariosDisponiveis={this.props.usuariosVendedores}
                        vendedoresSelecionados={this.state.usuarioEmpresaBloqueioSelecionados}
                        onAdicionar={this.selecionarVendedorParaBloquear.bind(this)}
                        onRemover={this.removerUarioEmpresaBloqueioSelecionados.bind(this)}
                    />
                                                
                    <div className="modal-footer">
                        <button type="submit" 
                             disabled={invalid || submitting || !this.state.dataInicio
                                || !this.state.dataFim || !this.state.usuarioEmpresaBloqueioSelecionados.length}
                            className="btn btn-laranja">Salvar</button>
                    </div>
                </form>
            </>
        );
    }

    render() {
        return (
            <div className="modal fade show" id='modalBloquearUsuarioEmpresaItinerarioPorEmLote' role='dialog'
                 aria-labelledby='modalBloquearUsuarioEmpresaItinerarioPorEmLote' aria-hidden='true' data-backdrop='static'>
                <div className={'modal-dialog modal-dialog-centered modal-xl'}>
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5>Bloquear cidades em lote</h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close"
                                    onClick={this.limparFormulario}>
                                <i className="material-icons">
                                    &#xe5cd;
                                </i>
                            </button>
                        </div>
                        <div className="modal-body">
                            {this.formulario()}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export function mapStateToProps(state) {
    return {
        empresaSelecionada: state.empresaSelecionada,        
        usuariosVendedores: state.usuariosVendedores,
    }
}

export const mapDispatchToProps = dispatch => (
    bindActionCreators({                
       changeFieldValue,
       bloquerUsuarioEmpresaItinerarioEmLote
    }, dispatch)
);

export default connect(mapStateToProps, mapDispatchToProps)(reduxForm({
    form: 'formularioBloquearUsuarioEmpresaItinerarioPorEmLote',
    enableReinitialize: true,
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
})(ModalBloquearUsuarioEmpresaItinerarioPorEmLote));


